import {
  CHANGE_PASS_REQUESTING,
  CHANGE_PASS_SUCCESS,
  CHANGE_PASS_ERROR,
} from './constants'

const initialState = {
  type: CHANGE_PASS_REQUESTING,
  data: {},
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  postData: {},
}

const reducer = function changePassReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case CHANGE_PASS_REQUESTING:
      return {
        ...state,
        type: action.type,
        data: {},
        requesting: true,
        successful: false,
        messages: [{ body: 'Đang xử lý...', time: new Date() }],
        errors: [],
        postData: action.payload,
      }

    // Successful?  Reset the changePass state.
    case CHANGE_PASS_SUCCESS: 
      return {
        ...state,
        type: action.type,
        data: {},
        errors: [],
        messages: [{
          body: action.message,
          time: new Date(),
        }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case CHANGE_PASS_ERROR:
      return {
        ...state,
        type: action.type,
        data: {},
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/ChangePassword/reducer.js